import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@Services/redux/Store';
import { initialWorkbenchState } from './State';

const WorkbenchSlice = createSlice({
    name: 'Workbench',
    initialState: initialWorkbenchState,
    reducers: {
        setWorkbench(state, action) {
            state.selectedWorkbench = action.payload;
        },
        setViewState(state, action) {
            state.viewState = action.payload;
        },
    },
});

export const WorkbenchActions = WorkbenchSlice.actions;

export const selectedWorkbenchState = (state: RootState) =>
    state.workbench.selectedWorkbench;
export const viewStateState = (state: RootState) => state.workbench.viewState;

export default WorkbenchSlice.reducer;
